import styles from "./styles/InfoButton.module.css";
const InfoButton = ({ onClickFuction, inputId, name }) => {
    return (
        <button
            className={`${styles.help_button} flex-container`}
            onClick={onClickFuction}
            name={name ? name : inputId}
            id={inputId}
            type={"button"}
            aria-label={`help button`}
        >
            ?
        </button>
    );
};

export default InfoButton;
